import { render, staticRenderFns } from "./reportes.vue?vue&type=template&id=6fe8968e&"
import script from "./reportes.vue?vue&type=script&lang=ts&"
export * from "./reportes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports